export default {
  organizers: {
    description: 'Organizer tools help you improve your time management skills.',
    type: {
      todo: {
        label: 'To-do',
        description:
          'Enjoy crossing completed things out. Get quick access to all shopping, work and any kind of personal lists.',
      },
      calendar: {
        label: 'Calendar',
        description:
          "Add structure to your life! See the future ... events, work tasks and you don't miss any of them.",
      },
      journal: {
        label: 'Journal',
        description:
          'Balance your personal and work life. Reach a higher level of productivity by getting your week structured.',
      },
      tasks: {
        label: 'Tasks',
        description:
          'Watch your progress and enjoy things getting done faster than ever with the easiest task journey.',
      },
      backlog: {
        label: 'Backlog',
        description:
          'Keep deferred tasks in one place, having access to all necessary information added to your assignment.',
      },
      budget: {
        label: 'Budget',
        description: 'Keep your spending in check and be sure your savings are on track for the future.',
      },
      cloud: {
        label: 'Cloud',
        description:
          ' Get more space to store your documents and photos. Divide them into folders to have quick access.',
      },
    },
    organizerInfoModalContainers: {
      backlog: {
        title1: 'No deadline needed',
        description1:
          "Work peacefully and enjoy the study process without any rush. If you don't have any specific deadline, set one in the process. So, you'll be no more tired of the scary due dates. You'll also have all tasks you need in Backlog and see the wholesome picture of the job to do. Reduce stress - use Backlog.",
        title2: 'Share, add notes and comments',
        description2:
          'Share tasks from Backlog with your friends to complete the job faster than ever. Click select members and choose someone from your Network in hubmee to add others to your task. Then all assignees you gave the right to edit can add photos, documents, notes, and comments. Now, you can also add checklists,, so you and your friends can cross the completed job out.',
        title3: "Everything's connected",
        description3:
          'Everything in hubmee is connected with each other. Therefore moving tasks from Backlog to Planner doesn\'t take much time. I promise. All you need to do is change the task status to anything except "Backlog" and it will automatically go to your Planner. The action works both ways. So, you can always change your mind and get things back as they were.',
        title4: 'Search by filters',
        description4:
          'Search tasks in Backlog quickly! Well designed filter system will make your time in hubmee comfortable and carefree. Use a few simple filters to help you sort your tasks and manage them.',
      },
      tasks: {
        title1: 'Visualize your path',
        description1:
          'Turn your aspirations into real progress with Tasks. In short, you will increase flexibility in the workflow. The Tasks tab also helps reduce backlogs. After adding people to the task, they will see at what stage of completing it you are. Now, building strategies will become easier by working together.',
        title2: 'Checklists, comments and notes',
        description2:
          'Add checklists, notes, and comments to avoid forgetting anything. Keep all the great ideas, suggestions and corrections in the task and get quick access to any small detail related to things you have to do.',
        title3: 'Filters',

        description3:
          'Filters will help you to separate your own assignments from common ones. User-friendly interface of the hubmee app gives you a chance to get your things done quickly.',
        title4: 'Task statuses',
        description4:
          "With hubmee, you will create a bold vision of your strategic goals. Then, track the progress of your task at every step. Watch your job moving towards its logical conclusion. Change task statuses, moving them to columns with a computer mouse or fingers. Having access to your colleagues' tasks make you understand",
      },
      journal: {
        title1: 'Well-ordered daily schedule',
        description1:
          "Boost your focus and productivity with hubmee. A well-ordered list of your plans won't give you a chance to forget something. So, no more long searches for tomorrow's plans in some worn paper notebook or chaotic phone notes. From now on, you'll proudly open the hubmee app and find any task and event you need in one click.",
        title2: 'Recurrence and priority',
        description2:
          'Keep everything in one app. Monthly shopping, weekly family dinner, meeting with friends, work zoom calls – schedule it in Planner. Choose the priority of the task you have to do immediately. Different colors will help your friends or colleagues to understand the importance level of the job. Use a recurrence tool for things you have to do constantly and watch you build more good habits every next two weeks. This is how we build habits in hubmee!',
        title3: 'Common tasks and statuses',
        description3:
          "Common tasks with people of your heart let you be closer to them and stay up-to-date. Adding task statuses helps to see a wholesome picture of your day. You'll get things done on time by planning together. Having a proper schedule makes it easy to get extra hours in your day for your friends and family. Enjoy!",
        title4: 'Events type',
        description4:
          'Create events on any occasion. Set up work google meetings and weekly online calls with friends from abroad in one minute. Just add people you want to meet online, fill in the link for the future meeting and get a notification 10 min before the event starts. Creating meetings in person is easy, too - add people, location and set the time. Write a short description if there is a need. Voila, the job is done.',
      },
      calendar: {
        title1: 'Wholesome picture of a month',
        description1:
          "Get all your appointments, birthdays, and monthly shopping in perfect order. Watch a wholesome picture of your month with Calendar. So, no more long searches for tomorrow's plans in some worn paper notebook or chaotic phone notes. From now on, you'll proudly open the hubmee app and find any task and event you need in one click.",
        title2: 'Statuses and filters',
        description2:
          'Add more structure to planning using different statuses. They help to see the whole picture more clearly. You will easily track all your future plans and add new ones anytime you need. Calendar suits people with a busy schedule and who want to spend less time planning things. hubmee app is quick and easy to use. Test it yourself and watch extra hours appear in your day!',
        title3: 'Details matter',
        description3:
          "Get a perfect calendar by adding description, photos, and checklists so you won't miss any important detail. This way, you'll make any event clear not only for yourself but for all attendees. And, of course, there will be no need to explain anything twice. It'll save you so much time having everything in one place.",
        title4: 'Recurrence and priority',
        description4:
          "Watch you build more good habits every next two weeks using a recurrence tool for things you want to do constantly. We are always here for you to add good habits to your routine. You can also choose the priority of the task you have to do immediately. In common tasks, different colors will help your friends or colleagues understand the job's importance level",
      },
      todo: {
        title1: 'Get things done quickly',
        description1:
          "Enjoy completing things one by one, starting with grocery lists and ending with work to-dos. Make even large and overwhelming projects manageable. Also, you get more done by focusing on high-value activities. Once you have a list of things you need to do, buy, write, etc., it's much easier to get them done. So you'll always be working on the right things.",
        title2: 'Templates',
        description2:
          "Use templates to create checklists faster. There's no need to invent things you already get in hubmee. Templates will save you much time, so you will increase productivity, use time wisely, and improve time management and workflow. And most importantly, you won't forget a thing by keeping everything in one app.",

        title3: 'Convert Checklist to Task',

        description3:
          'Everything in hubmee is connected, which means you can make a task out of a checklist. And its items will automatically go to the checklist section of the task. In the same way, you can make a task out of any item by itself. Less effort from your side - still more things done. Sounds just perfect!',

        title4: 'Share',
        description4:
          'Share cleaning, party and work lists with your friends and watch everything gets done even faster. Completing things together helps you build stronger relationships with your friends, family, and colleagues.',
      },
    },
  },
};
